import React, { useState, useRef, useEffect } from 'react';
import classNames from "classnames";
import Icons from '../../../component/module.icons';

function FileDropZone(props) {
  const [files, setFiles] = useState([]);
  const dropZoneRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const dz = dropZoneRef.current;
    if (!dz) return;

    function onDragOver(e) {
      e.preventDefault();
      dz.classList.add('dragover');
    }
    function onDragLeave(e) {
      e.preventDefault();
      dz.classList.remove('dragover');
    }
    function onDrop(e) {
      e.preventDefault();
      dz.classList.remove('dragover');

      const droppedFiles = Array.from(e.dataTransfer.files);
      // Filter out files not matching allowed types
      const allowedTypes = ['image/png', 'image/jpeg', 'image/webp', 'video/webm', 'video/mp4'];
      const validFiles = droppedFiles.filter(file => allowedTypes.includes(file.type));
      setFiles(current => [...current, ...validFiles]);
      
    

      // Mirror into hidden input so you can submit normally:
      const dt = new DataTransfer();
      validFiles.forEach(file => dt.items.add(file));
      if (inputRef.current) {
        inputRef.current.files = dt.files;
      }
    }

    dz.addEventListener('dragover', onDragOver);
    dz.addEventListener('dragleave', onDragLeave);
    dz.addEventListener('drop', onDrop);

    return () => {
      dz.removeEventListener('dragover', onDragOver);
      dz.removeEventListener('dragleave', onDragLeave);
      dz.removeEventListener('drop', onDrop);
    };
  }, []);


  useEffect(() => {
    if (files) {
        props.setBulkFiles(files);
    } 
    return() => {
        props.setBulkFiles(false)
    }
  }, [files])

  function removeFile(idx) {
    setFiles(currentFiles => {
      // Remove the file at the given index
      const newFiles = currentFiles.filter((_, i) => i !== idx);
      // Mirror changes into the hidden input for normal form submission
      const dt = new DataTransfer();
      newFiles.forEach(file => dt.items.add(file));
      if (inputRef.current) {
        inputRef.current.files = dt.files;
      }
      return newFiles;
    });
  }



  return (
    <div className="dropZoneWrap">
      <span ref={dropZoneRef} className={classNames("dropZone", (files.length > 0) && "dropZoneHasFiles")}>
           {files.length === 0 && <span className="dropZoneLabel">
                <Icons.BulkUpload className="iconLg" />
                <h4>Drop files here</h4>
                <input type="file" style={{display: "none"}} id="dropZoneFiles" accept={"image/png, image/jpeg, image/webp, video/webm, video/mp4"} multiple={true} />
            </span>}
         {files.length > 0 && (
        <ul className="dropZoneFiles">
          {files.map((file, idx) => (
            <li key={idx} className="flex spaceBetween alignCenter">
              {file.name} ({(file.size / 1024).toFixed(1)} KB) <Icons.Trash className="icon ui" onClick={() => removeFile(idx)} />
            </li>
          ))}
        </ul>
      )}
      </span>
      
      <input
        id="dropZoneFiles"
        ref={inputRef}
        type="file"
        multiple
        style={{ display: 'none' }}
      />

     
    </div>
  );
}

export default FileDropZone;